export const SERVER_URL = "https://enatega-multivendor.up.railway.app/";